import React, { useState, useContext } from 'react'
import { v4 as uuidv4 } from 'uuid';
import { Box, Button, TextField } from '@mui/material';

import MyModal from "./MyModal"
import APIS from "../../utils/APIS"
import { PopupNotifContext } from "../../contexts/PopupNotifContext"

import closeIcon from '../../images/closeIcon.svg';

// S8 : bouton « Upgrade » de la maquette. Ouvre un formulaire ou le recruteur
// decrit ce qu'il aimerait avoir en plus ; la demande part a l'equipe Rising Up.

const BESOINS = [
  "Plus de scans par mois",
  "Plus de candidats par scan",
  "Des soft skills sur mesure",
  "Un accompagnement à l'analyse des résultats",
  "Autre",
]

const UpgradeModal = ({ isOpen, onClose, currentUser }) => {
  const { addPopupNotif } = useContext(PopupNotifContext)

  const [choisis, setChoisis] = useState([])
  const [message, setMessage] = useState("")
  const [envoi, setEnvoi] = useState(false)
  const [envoye, setEnvoye] = useState(false)

  const bascule = (item) => {
    setChoisis((act) => act.includes(item) ? act.filter((el) => el !== item) : [...act, item])
  }

  const fermer = () => {
    onClose()
    setTimeout(() => { setChoisis([]); setMessage(""); setEnvoye(false) }, 500)
  }

  const envoyer = () => {
    setEnvoi(true)
    APIS.askForUpgrade({ besoins : choisis, message : message.trim() }).then((result) => {
      if (result?.message === "askForUpgrade") {
        setEnvoye(true)
      } else {
        addPopupNotif({ uuid : uuidv4(), text : "Une erreur est survenue", type : "error", removeAfter : 5000 })
      }
      setEnvoi(false)
    })
  }

  return (
    <MyModal isOpen={isOpen} maxWidth="sm" onClose={fermer} background="white">
      <Box sx={{padding:["25px 20px", "35px 30px"], display:"flex", flexDirection:"column", minHeight:"380px"}}>
        <Box sx={{display:"flex", justifyContent:"flex-end"}}>
          <img src={closeIcon} style={{width:"18px", height:"18px", cursor:"pointer"}} onClick={fermer} alt=""/>
        </Box>

        {envoye ? (
          <Box sx={{flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"14px", textAlign:"center"}}>
            <Box sx={{fontSize:"26px", color:"text.black"}}>Demande envoyée</Box>
            <Box sx={{fontSize:"16px", color:"#565656", maxWidth:"380px"}}>
              Merci. L'équipe Rising Up revient vers vous sous 1 à 2 jours ouvrés.
            </Box>
            <Button variant="contained" size="large" onClick={fermer} sx={{marginTop:"10px", minWidth:"160px"}}>
              Fermer
            </Button>
          </Box>
        ) : (
          <>
            <Box sx={{fontSize:"26px", color:"text.black", marginBottom:"6px"}}>
              Faire évoluer votre offre
            </Box>
            <Box sx={{fontSize:"16px", color:"#565656", marginBottom:"22px"}}>
              Dites-nous ce que vous aimeriez avoir en plus, nous vous recontactons.
            </Box>

            <Box sx={{display:"flex", flexWrap:"wrap", gap:"10px", marginBottom:"22px"}}>
              {BESOINS.map((item, index) => {
                const actif = choisis.includes(item)
                return (
                  <Box
                    key={index}
                    onClick={() => bascule(item)}
                    sx={{
                      fontSize:"14px",
                      padding:"9px 14px",
                      cursor:"pointer",
                      userSelect:"none",
                      border: actif ? "1px solid black" : "1px solid #E7E7E7",
                      background: actif ? "#F4F4F4" : "white",
                      color: actif ? "text.black" : "#565656",
                      "&:hover" : { border:"1px solid black" },
                    }}
                  >
                    {item}
                  </Box>
                )
              })}
            </Box>

            <TextField
              multiline
              minRows={4}
              fullWidth
              placeholder="Décrivez votre besoin (facultatif)"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              variant="outlined"
              sx={{"& .MuiInputBase-input" : { color:"black" }}}
            />

            <Box sx={{paddingTop:"22px"}}>
              <Button
                fullWidth
                size="large"
                variant="contained"
                disabled={envoi || (choisis.length === 0 && message.trim().length < 5)}
                onClick={envoyer}
              >
                Envoyer ma demande
              </Button>
            </Box>
          </>
        )}
      </Box>
    </MyModal>
  )
}

export default UpgradeModal
